import React, { useEffect, Fragment, useState, useRef } from 'react';
import { Button, Card, Col, Form, Modal, Row } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import { LoadingComponent } from 'recupero-comunes';
import { FaSearch } from "react-icons/fa";
import { serviceGetDetalles, serviceGetHistoriaGastos, serviceGetHitos, serviceGetInforme } from '../../api/api-consulta-hitos';
import { formato_monto } from '../../common/Formatos';


const TrazabilidadHitos = ({ showModal, setShowModal, idCaso, idOrgCaso, tipoGestion }) => {
    const { SearchBar, ClearSearchButton } = Search;
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);

    const [tiposGestion, setTiposGestion] = useState([]);
    const [ambitosGestion, setAmbitosGestion] = useState([]);

    const [stateTipoGestion, setStateTipoGestion] = useState("");
    const [stateAmbitoGestion, setStateAmbitoGestion] = useState("");
    const [stateHistorialReasignado, setStateHistorialReasignado] = useState(false);

    const columnas = [
        {
            dataField: 'glosaHito',
            text: 'Hito',
            sort: true, headerAlign: 'center', align: 'center',
            headerStyle: { color: 'white', backgroundColor: '#7594C1' },
            headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{column.text}<br />{sortElement}</div>)
        },
        {
            dataField: 'glosaTipoGestion',
            text: 'Gestión', sort: true, headerAlign: 'center', align: 'center',
            headerStyle: { color: 'white', backgroundColor: '#7594C1' },
            headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{column.text}<br />{sortElement}</div>)
        },
        {
            dataField: 'glosaAmbitoGestion',
            text: 'Ambito',
            sort: true, headerAlign: 'center', align: 'center',
            headerStyle: { color: 'white', backgroundColor: '#7594C1' },
            headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{column.text}<br />{sortElement}</div>)
        },
        {
            dataField: 'fechaHitoFormat',
            text: 'Fecha Ocurrencia',
            sort: true, headerAlign: 'center', align: 'center',
            headerStyle: { color: 'white', backgroundColor: '#7594C1' },
            headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{column.text}<br />{sortElement}</div>)
        },
        {
            dataField: 'comentario',
            text: 'Comentario',
            sort: true, headerAlign: 'center', align: 'center',
            headerStyle: { color: 'white', backgroundColor: '#7594C1' },
            headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{column.text}<br />{sortElement}</div>)
        },
        {
            dataField: 'usuario',
            text: 'Usuario',
            sort: true, headerAlign: 'center', align: 'center',
            headerStyle: { color: 'white', backgroundColor: '#7594C1' },
            headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{column.text}<br />{sortElement}</div>)
        },
        {
            dataField: 'fechaRegistroHitoFormat',
            text: 'Fecha Registro',
            sort: true, headerAlign: 'center', align: 'center',
            headerStyle: { color: 'white', backgroundColor: '#7594C1' },
            headerFormatter: (column, colIndex, { sortElement, filterElement }) => (<div>{column.text}<br />{sortElement}</div>)
        },
        {
            dataField: 'opciones',
            text: '',
            isDummyField: true,
            style: { textAlign: 'center', verticalAlign: 'middle' },
            headerStyle: (colum, colIndex) => {
                return { width: '5%', textAlign: 'center', verticalAlign: 'center', backgroundColor: '#7594C1', color: 'white' }
            },
            formatter: (cell, row) => {
                return <FaSearch
                    size={20}
                    title={row.folioCarga ? "Ver Documentación del Hito" : "No existe documentación"}
                    style={{ color: 'gray', cursor: row.folioCarga ? 'pointer' : 'not-allowed' }}
                    onClick={() => handleInforme(row.idImplicadoCasoHito, row.folioCarga)}
                />
            },
        }
    ];

    useEffect(() => {
        if (showModal) initialData();
    }, [showModal])

    const initialData = async () => {
        await getTiposGestion();
        await getAmbitosGestion();
        await getTrazabilidadesHitos();
    }

    const getTiposGestion = async () => {
        setLoading(true);
        let query = Buffer.from(JSON.stringify({ concepto: 207 })).toString('base64');

        const response = await serviceGetDetalles(query);
        setLoading(false);
        setTiposGestion(response);
        setStateTipoGestion(tipoGestion);
    }

    const getAmbitosGestion = async () => {
        setLoading(true);
        let query = Buffer.from(JSON.stringify({ concepto: 232 })).toString('base64');

        const response = await serviceGetDetalles(query);
        setLoading(false);
        setAmbitosGestion(response);
    }

    const handleClose = async () => {
        setShowModal(false);
        setStateTipoGestion("");
        setStateAmbitoGestion("");
        setStateHistorialReasignado(false);
        setData([]);
    }

    const getTrazabilidadesHitos = async () => {
        setLoading(true);
        const query = Buffer.from(JSON.stringify({
            idCaso: idCaso,
            idImplicado: 999,
            idModoIngreso1: null,
            idModoIngreso2: null,
            tipoGestion: stateTipoGestion !== "" ? stateTipoGestion : tipoGestion,
            ambitoGestion: stateAmbitoGestion !== "" ? stateAmbitoGestion : null,
            responsableReasignado: stateHistorialReasignado,
        })).toString('base64');

        const response = await serviceGetHitos(query);
        setData(response);
        setLoading(false);
    }

    const handleInforme = async (idImplicado, folioCarga) => {
        if (folioCarga) {
            setLoading(true);
            let query = Buffer.from(JSON.stringify({
                idCaso: idCaso,
                idImplicadoCaso: idImplicado ? idImplicado : 0,
                idCompania: idOrgCaso,
                idfolioCarga: folioCarga
            })).toString('base64')

            const response = await serviceGetInforme(query);
            setLoading(false);

            var link = document.createElement("a");
            link.download = response.filename;
            link.href = "data:" + response.mimetype + ";base64," + response.file;
            link.click();
        }
    }

    return (
        <Fragment>
            <LoadingComponent show={loading} />
            <Modal show={showModal} onHide={handleClose} size='xl'>
                <Card>
                    <Card.Header className='cardHeader'>
                        TRAZABILIDAD DE HITOS
                    </Card.Header>

                    <Card.Body>
                        <Row>
                            <Col md='3'>
                                <Form.Label>
                                    Tipo Gestión
                                </Form.Label>
                                <Form.Select
                                    name='stateTipoGestion'
                                    onChange={(e) => setStateTipoGestion(e.target.value)}
                                    value={stateTipoGestion}>

                                    {tiposGestion && tiposGestion
                                        .map((i, index) => (<option key={index} value={i.id}>{i.nombre}</option>))
                                    }
                                </Form.Select>
                            </Col>
                            <Col md='3'>
                                <Form.Label>
                                    Ambito Gestión
                                </Form.Label>
                                <Form.Select
                                    name='stateAmbitoGestion'
                                    onChange={(e) => setStateAmbitoGestion(e.target.value)}
                                    value={stateAmbitoGestion}>

                                    <option value={""}>Seleccione</option>
                                    {ambitosGestion && ambitosGestion
                                        .map((i, index) => (<option key={index} value={i.id}>{i.nombre}</option>))
                                    }
                                </Form.Select>
                            </Col>
                            <Col md='4'>
                                <Form.Check
                                    style={{ marginTop: '35px' }}
                                    name="stateHistorialReasignado"
                                    label="Historial Reasignado"
                                    checked={stateHistorialReasignado}
                                    onChange={(e) => setStateHistorialReasignado(e.target.checked)}
                                />
                            </Col>
                        </Row>

                        <hr style={{ borderTop: '2px solid #04005D' }}></hr>

                        <Row>
                            <Col className="d-grid d-md-flex justify-content-md-end">
                                <Button style={{ width: '110px', marginRight: '5px' }} variant='outline-info' onClick={handleClose}>Volver</Button>
                                <Button style={{ width: '110px', color: 'white' }} variant='info' onClick={getTrazabilidadesHitos}>Buscar</Button>
                            </Col>
                        </Row>

                        <hr style={{ borderTop: '2px solid #04005D' }}></hr>

                        <ToolkitProvider
                            search
                            bootstrap4
                            keyField="id"
                            data={data ? data : []}
                            columns={columnas}
                            defaultSorted={[{ dataField: 'id', order: 'asc' }]}>
                            {props =>
                                <>
                                    <Row>
                                        <Col className="d-grid d-md-flex justify-content-md-end mb-2">
                                            <SearchBar {...props.searchProps} srText="" placeholder="Buscar en grilla" />
                                            <ClearSearchButton {...props.searchProps} text="Limpiar" className="customSearch" />
                                        </Col>
                                    </Row>
                                    <BootstrapTable
                                        {...props.baseProps}
                                        headerWrapperClasses="table-secondary"
                                        pagination={ paginationFactory({ sizePerPage: 5}) }
                                        noDataIndication={
                                            <div className="text-center">No hay registros encontrados.</div>
                                        }
                                    />
                                </>
                            }
                        </ToolkitProvider>
                    </Card.Body>
                </Card>
            </Modal>

            <style type='text/css'>
                {`
                    .table>:not(:first-child) {
                        border-top: none;
                    }
                    .customSearch {
                        color: #fff;
                        background-color: #ffc107;
                        border-color: #ffc107;
                    }
                `}
            </style>
        </Fragment>
    )
}

export default TrazabilidadHitos